import Request from './index';

export const GetCommentsByIdeaID = async (pk = '') => {
  const endpoint = `/api-my-ideas/comments/${pk}`;

  return await Request.get({ url: endpoint });
}
